import { QRCode } from "@pandas/components";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/common/Buttons/Button";
import Popup from "@/components/common/Popups/Popup";
import LoadingDots from "@/components/LoadingDots";
import useInitializationParams from "@/hooks/useInitializationParams";
import useUrlShortener from "@/hooks/useUrlShortener";
import { useStore } from "@/store";
import { getRedirectToDeviceParams } from "@/utils/initializationHelpers";
import { getVisionAppBaseUrl } from "@/utils/urlHelpers";

export const Route = createFileRoute("/$locale/$partner/_app/_card/pair-scanner-device")({
	component: PairScannerDevice,
});

function PairScannerDevice() {
	const { t, i18n } = useTranslation();
	const sessionId = useStore((state) => state.sessionId);
	const [showModal, setShowModal] = useState(false);
	const { shortUrl, getShortUrl } = useUrlShortener();
	const { partnerToken, locationId, partnerCode } = useInitializationParams();
	const redirectToDeviceParams = getRedirectToDeviceParams({ sessionId, partnerToken, partnerCode, locationId });

	const locale = i18n.language;
	const partner = partnerCode || "pandas";
	const url = `${getVisionAppBaseUrl()}/${locale}/${partner}/imei-instructions?${redirectToDeviceParams}`;

	return (
		<>
			<div className="flex flex-col items-center text-center justify-between h-full relative">
				<div className="flex flex-col justify-between items-center h-2/3">
					<div>
						<h3 className="pt-10 sm:pt-20 pb-2">{t("instructions.Scan the QR code with the scanner device")}</h3>
						<p>
							{t(
								"instructions.We’ll use your scanner device’s camera to take a quick look at the condition of the device you want to evaluate.",
							)}
						</p>
					</div>
					<div className="text-center max-w-2xl">
						{sessionId && (
							<QRCode
								id="qr-code"
								size={250}
								className="bg-white rounded-lg p-4 sm:p-8 mx-auto w-[180px] h-[180px] sm:w-[300px] sm:h-[300px]"
								value={url}
							/>
						)}
					</div>
				</div>
				<Button
					intent="tertiary"
					onClick={() => {
						getShortUrl(url);
						setShowModal(true);
					}}
					label={t("btn.Can’t scan QR code?")}
				/>
			</div>
			<Popup
				show={showModal}
				setShow={setShowModal}
				content={
					<div className="flex flex-col justify-center items-center h-full">
						<h4 className="my-6">{t("info pop ups.Visit")}</h4>
						<div className="bg-lightgrey p-4 rounded-lg">{shortUrl ? shortUrl : <LoadingDots />}</div>
					</div>
				}
			/>
		</>
	);
}
